import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=41b6ef4f&scoped=true"
import script from "./Mall.vue?vue&type=script&lang=js"
export * from "./Mall.vue?vue&type=script&lang=js"
import style0 from "./Mall.vue?vue&type=style&index=0&id=41b6ef4f&prod&scoped=true&lang=css"
import style1 from "./Mall.vue?vue&type=style&index=1&id=41b6ef4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b6ef4f",
  null
  
)

export default component.exports